<template>
    <div>
        <div>
            <span>보유포인트: {{ me?.point?.format() || 0 }}원</span>
        </div>

        <div class="mt-8">
            <v-combobox 
                v-model="order.paymentAmount" 
                :items="paymentAmounts" 
                @input="rename()"

                dense 
                outlined 
                hide-details 
                
                label="충전금액"
                class="d-inline-block mx-2">

                <template v-slot:selection="{item}">
                    <v-icon color="blue" left>mdi-alpha-p-circle</v-icon>
                    <span>{{ parseInt(item).format() }}</span>
                </template>

                <template v-slot:item="{item}">
                    <v-icon color="grey" left>mdi-alpha-p-circle</v-icon>
                    <span>{{ parseInt(item).format() }}</span>
                </template>
                
            </v-combobox>

            <v-btn color="primary" @click="charge()">충전하기</v-btn>
        </div>

        <nice-pay ref="nicepay" @complete="payload => { complete(payload), init() }" />
    </div>
</template>

<script>
import api from "@/api";
import nicePay from '@/components/plugins/nicepayments/nice-pay.vue';

export default {
    components: {
        nicePay
    },
    data(){
        return {
            paymentAmounts: [
                1000, 3000, 5000,
                10000, 30000, 50000
            ],

            order: {
                orderName: "주문명칭 또는 구매상품명칭",

                paymentAmount: 0,
                paymentMethod: "card",
                paymentGateway: "nicepay",
            }
        }
    },
    mounted(){
        this.$store.dispatch("getUser");
    },
    methods: {
        rename(){
            this.order.orderName = `${this.order.paymentAmount} 포인트 구매`;
        },
        async charge(){
            // 0. 예외처리
            if(this.logOff){
                alert("로그인 후 충전 가능합니다");
                return;
            }

            // 1. 주문서를 등록합니다. (주문명칭, 결제금액 등)
            let { order } = await api.v1.me.points.orders.post(this.order);

            // 2. 결제대행사(PG업체)에 주문정보를 전달합니다.
            this.$refs.nicepay.collection = "user-point-orders";
            this.$refs.nicepay.orderNo = order.orderNo;
            this.$refs.nicepay.orderName = order.orderName;
            this.$refs.nicepay.paymentMethod = order.paymentMethod;
            this.$refs.nicepay.paymentGateway = order.paymentGateway;
            this.$refs.nicepay.paymentAmount = order.paymentAmount;
            this.$refs.nicepay.buyerName = order.buyer.name;
            this.$refs.nicepay.buyerPhone = order.buyer.phone;
            this.$refs.nicepay.buyerEmail = order.buyer.email;

            // 3. 결제창 호출
            this.$refs.nicepay.pay();
        },
        async complete(payload){
            // 결제대행사로부터 결제결과 메세지를 사용자에게 보여줍니다.
            alert(`[${payload.resCode}] ${payload.resMessage}`);
            
            // 사용자 보유포인트(프로필) 갱신
            await this.$store.dispatch("getUser");
        },
    },
    computed: {
        me(){ return this.$store.state.user; },
        logOn(){ return !!this.$store.state.accessToken; },
        logOff(){ return !this.$store.state.accessToken; },
    }
}
</script>